const bomPlanSystemSelections = new Map();
let bomPlanCaptureInProgress = false;

function normalizeSystemId(value) {
  return String(value || '').trim();
}

function normalizeSelectionSet(ids) {
  const values = ids instanceof Set || Array.isArray(ids) ? ids : [];
  return new Set([...values]
    .map(value => String(value || '').trim())
    .filter(Boolean));
}

function setBomPlanCaptureInProgress(value) {
  const previous = bomPlanCaptureInProgress;
  bomPlanCaptureInProgress = value === true;
  return previous;
}

function restoreBomPlanCaptureInProgress(value) {
  bomPlanCaptureInProgress = value === true;
}

function isBomPlanCaptureInProgress() {
  return bomPlanCaptureInProgress === true;
}

function setBomPlanSystemSelections(selectionMap) {
  bomPlanSystemSelections.clear();
  if (!selectionMap || typeof selectionMap.entries !== 'function') return;
  for (const [systemIdValue, ids] of selectionMap.entries()) {
    const systemId = normalizeSystemId(systemIdValue);
    if (!systemId) continue;
    bomPlanSystemSelections.set(systemId, normalizeSelectionSet(ids));
  }
}

function clearBomPlanSystemSelections(systemIds = null) {
  if (!Array.isArray(systemIds) || !systemIds.length) {
    bomPlanSystemSelections.clear();
    return;
  }
  for (const value of systemIds) {
    const systemId = normalizeSystemId(value);
    if (systemId) bomPlanSystemSelections.delete(systemId);
  }
}

function getBomPlanSystemSelection(systemIdValue) {
  const systemId = normalizeSystemId(systemIdValue);
  const set = systemId ? bomPlanSystemSelections.get(systemId) : null;
  return set instanceof Set ? new Set(set) : null;
}

function isBomPlanSystemSelectionActive(systemIdValue) {
  const systemId = normalizeSystemId(systemIdValue);
  return Boolean(systemId) && bomPlanSystemSelections.has(systemId);
}

function isBomPlanRendering() {
  return bomPlanSystemSelections.size > 0;
}

export {
  setBomPlanCaptureInProgress,
  restoreBomPlanCaptureInProgress,
  isBomPlanCaptureInProgress,
  setBomPlanSystemSelections,
  clearBomPlanSystemSelections,
  getBomPlanSystemSelection,
  isBomPlanSystemSelectionActive,
  isBomPlanRendering
};

export function snapshotBomPlanSystemSelections() {
  return new Map([...bomPlanSystemSelections].map(([owner, ids]) => [owner, new Set(ids)]));
}
